import type { IUseCase } from 'shared-kernel';
import type { ITwoFactorRepository } from '../../../domain/ports';

export interface Deactivate2FAInput {
  idUtilisateur: string;
  motDePasse: string;
  codeVerification: string;
}

export class Deactivate2FAUseCase implements IUseCase<Deactivate2FAInput, void> {
  constructor(
    private readonly twoFactorRepository: ITwoFactorRepository,
  ) {}

  async execute(input: Deactivate2FAInput): Promise<void> {
    const response = await this.twoFactorRepository.deactivate(input);

    if (!response.succes) {
      throw new Error(response.message || 'Echec de la desactivation 2FA');
    }
  }
}
